
window.WOODPreview = (() => {

  window.WOOD_STATE =
  window.WOOD_STATE || {};

window.WOOD_STATE.activeTextLayer =
  window.WOOD_STATE.activeTextLayer || null;

  function getEls() {
    return window.els || {};
  }

  /* =========================
     DRAG SYSTEM
  ========================= */

  function makeElementDraggable(el) {

    const els = getEls();

    if (!el || !els.preview) return;

    let isDragging = false;

    let startX = 0;
    let startY = 0;

    let initialLeft = 0;
    let initialTop = 0;

    el.style.position = "absolute";
    el.style.touchAction = "none";
    el.style.userSelect = "none";

    el.addEventListener("pointerdown", function (e) {

      isDragging = true;

      startX = e.clientX;
      startY = e.clientY;

      initialLeft =
        parseFloat(el.style.left) || 0;

      initialTop =
        parseFloat(el.style.top) || 0;

      if (el.setPointerCapture) {
        el.setPointerCapture(e.pointerId);
      }

      e.preventDefault();

    });

    el.addEventListener("pointermove", function (e) {

      if (!isDragging) return;

      const dx = e.clientX - startX;
      const dy = e.clientY - startY;

      let newLeft = initialLeft + dx;
      let newTop = initialTop + dy;

      const maxLeft =
        els.preview.clientWidth - el.offsetWidth;

      const maxTop =
        els.preview.clientHeight - el.offsetHeight;

      newLeft = Math.max(
        0,
        Math.min(newLeft, maxLeft)
      );

      newTop = Math.max(
        0,
        Math.min(newTop, maxTop)
      );

      el.style.left = newLeft + "px";
      el.style.top = newTop + "px";

    });

    el.addEventListener("pointerup", function (e) {

      isDragging = false;

      if (
        el.hasPointerCapture &&
        el.hasPointerCapture(e.pointerId)
      ) {
        el.releasePointerCapture(e.pointerId);
      }

      if (window.WOODStorage?.save) {
        window.WOODStorage.save();
      }

    });

  }

  /* =========================
     SHAPE PREVIEW
  ========================= */

  function updateShape() {

  console.log("updateShape fired");

  const els = getEls();

    if (!els.shapeSelector || !els.baseWoodImage) return;

    const shape = els.shapeSelector.value;

    const baseImage = els.baseWoodImage;

    baseImage.style.borderRadius = "";
    baseImage.style.clipPath = "";
    baseImage.style.webkitClipPath = "";

    let newSrc = "";

    switch (shape) {

      case "round":

        newSrc =
          "https://cdn.shopify.com/s/files/1/0697/1978/5705/files/sannarita-signature-round.png?v=1776178451";

        baseImage.style.clipPath =
          "circle(50% at 50% 50%)";

        break;

      case "rectangle":

        newSrc =
          "https://cdn.shopify.com/s/files/1/0697/1978/5705/files/sannarita-signature-rectangle.png?v=1776184545";

        break;

      case "arch":

        newSrc =
          "https://cdn.shopify.com/s/files/1/0697/1978/5705/files/sannarita-signature-Arch.png?v=1776177899";

        baseImage.style.borderTopLeftRadius =
          "300px";

        baseImage.style.borderTopRightRadius =
          "300px";

        break;

    }

    console.log("Shape selected:", shape);
console.log("New image src:", newSrc);

if (newSrc) {
  baseImage.src = newSrc;
}

    updateStain();

  }

  /* =========================
     STAIN PREVIEW
  ========================= */

  function updateStain() {

    const els = getEls();

    if (!els.baseWoodImage) return;

    const stain =
      els.stainSelector?.value || "none";

    switch (stain) {

      case "espresso":

        els.baseWoodImage.style.filter =
          "brightness(0.72) sepia(0.55) saturate(1.2)";

        break;

      case "grey":

        els.baseWoodImage.style.filter =
          "grayscale(0.9) brightness(0.9)";

        break;

      case "black":

        els.baseWoodImage.style.filter =
          "brightness(0.45) contrast(1.1)";

        break;

      default:

        els.baseWoodImage.style.filter = "none";

    }

  }

  /* =========================
     TEXT STYLE
  ========================= */

  function updateTextStyle() {

    const els = getEls();

    document
      .querySelectorAll(".draggable-text")
      .forEach(el => {

        el.classList.remove(
          "text-flat",
          "text-raised"
        );

        if (els.textStyle?.value === "flat") {
          el.classList.add("text-flat");
        }

        if (els.textStyle?.value === "raised") {
          el.classList.add("text-raised");
        }

      });

  }

  /* =========================
     TEXT LAYER SELECTION
  ========================= */

  function selectTextLayer(el) {

    document
      .querySelectorAll('.draggable-text[data-extra="true"]')
      .forEach(t => {
        t.classList.remove("selected-text");
      });

    window.WOOD_STATE.activeTextLayer = el;

    if (window.WOOD_STATE.activeTextLayer) {
  window.WOOD_STATE.activeTextLayer.classList.add(
    "selected-text"
  );
  }

}   // <---- THIS IS MISSING

  /* =========================
     ADD TEXT LAYER
  ========================= */

  function createTextLayer() {

    const els = getEls();

    if (!els.addonLayer) return;

    const newText = document.createElement("div");

    newText.className = "draggable-text";

    newText.dataset.extra = "true";
    newText.contentEditable = true;

    newText.textContent = "New Text";

    newText.style.position = "absolute";

    newText.style.top = "120px";

    newText.style.left = "120px";

    newText.style.fontSize =
      (els.textSizeSlider?.value || 28) + "px";

    newText.style.color =
      els.textColorPicker?.value || "#000";

    newText.style.fontFamily =
      els.previewText?.style.fontFamily || "serif";

    newText.style.zIndex = "99999";

    els.addonLayer.appendChild(newText);

    makeElementDraggable(newText);

    newText.addEventListener("click", function (e) {

      e.stopPropagation();

      selectTextLayer(newText);

    });

    selectTextLayer(newText);

  }

  /* =========================
     EXPORT
  ========================= */

  async function exportDesign() {

    const els = getEls();

    if (typeof html2canvas === "undefined") {
      return;
    }

    try {

  const canvas = await html2canvas(
    els.preview,
    {
      scale: 2,
      useCORS: true,
      backgroundColor: null,
      logging: false
    }
  );

  const link = document.createElement("a");

  link.download = "my-design.png";
  link.href = canvas.toDataURL("image/png");

  link.click();

} catch(error) {

  console.error("EXPORT FAILED:", error);

}

    const link = document.createElement("a");

    link.download = "my-design.png";

    link.href = canvas.toDataURL("image/png");

    link.click();

  }

  /* =========================
     INIT
  ========================= */

  function init() {

    const els = getEls();

    if (els.previewText) {
  makeElementDraggable(els.previewText);
}

if (els.imageWrapper) {
  makeElementDraggable(els.imageWrapper);
}

    

    if (els.stainSelector) {

      els.stainSelector.addEventListener(
        "change",
        updateStain
      );

    }

    if (els.addTextLayerBtn) {

      els.addTextLayerBtn.addEventListener(
        "click",
        createTextLayer
      );

    }

    if (els.exportBtn) {

      els.exportBtn.addEventListener(
        "click",
        exportDesign
      );

    }

    updateShape();
    updateStain();
    updateTextStyle();

  }

  return {
    init,
    makeElementDraggable,
    updateShape,
    updateStain,
    updateTextStyle,
    selectTextLayer,
    createTextLayer
  };

})();